import * as React from 'react';
import { styled } from '@mui/material/styles';
import Rating from '@mui/material/Rating';

const StyledRating = styled(Rating)({
  '& .MuiRating-iconFilled': {
    color: '#FFE234',
  },
  '& .MuiRating-iconHover': {
    color: '#FFE234',
  },
  '& .MuiRating-iconEmpty': {
    color: '#FFE234',
  },
});

const CustomRating = ({ ...props }) => {
  return <StyledRating {...props} />;
};

export default CustomRating;
